import React, { useState } from 'react';
import { FormControl, FormLabel, FormHelperText, Paper, useForkRef, Typography, TextField, Button, CircularProgress, Fade, Backdrop } from '@material-ui/core';
// import Signature from './Signature';
import _, { omit, pick, round, slice } from 'lodash';
import PF from "../_Services/publicFunction";
import Qs from "qs";
import { DarkModeSwitch } from 'react-toggle-dark-mode';
import { useDispatch, useSelector } from "react-redux";
import { actions } from "../reducers/app";
import useSound from 'use-sound';
import switchlight from '../sounds/switchlight.wav';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { MuiPickersUtilsProvider, KeyboardDatePicker, DatePicker, KeyboardDateTimePicker, KeyboardTimePicker } from "@material-ui/pickers";
import TodayIcon from "@material-ui/icons/UpdateOutlined";
import MomentUtils from "@date-io/moment";
import moment from "moment";
import { useSnackbar } from "notistack";
// import Example from "./components/LHTable/Example"
import InteriorTable from "../components/LHTable/DataSheet_Virtual"
import Example from '../components/LHTable/Example';
import { indigo, teal, deepPurple } from '@material-ui/core/colors'


const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },

    half_background: {
        background: "linear-gradient(to top, yellow 50%, transparent 50%)"
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
    "data-grid": {
        width: "100%"
    }
}));
const WeeklyBooking = props => {
    const { enqueueSnackbar } = useSnackbar();
    const dispatch = useDispatch();
    const classes = useStyles();
    const initialRender = React.useRef(true);
    const { dark } = useSelector(state => ({
        dark: state.app.dark,
    }));
    const formRef = React.createRef();
    const [playActive] = useSound(
        switchlight,
        { volume: 0.5 }
    );
    const [loading, setLoading] = React.useState(false);

    //查詢條件
    const [MornJoy, setMornJoy] = React.useState({
        // CheckDate: { name: "CheckDate", label: "預約日期", format: "date", required: true, value: null },
        startDate: { name: "startDate", label: "預約日期(起)", format: "date", required: true, value: null },
        endDate: { name: "endDate", label: "預約日期(迄)", format: "date", required: true, value: null },
        personalId: { name: "personalId", label: "身分ID", required: true },
    })
    const [rows, setRows] = useState([]);
    //選中的範圍
    const [selected, setSelected] = React.useState({ start: null, end: null })
    //用於表的快速移動至某行
    const listRef = React.createRef();
    //勾選
    const [checkSelections, setCheckSelections] = React.useState(new Map());
    //允許多個勾選
    const [enableCheck, setEnableCheck] = React.useState(false);
    //允許多個勾選
    const [multiChk, setMultiChk] = React.useState(false);
    //總頁數
    const [pageCount, setPageCount] = React.useState(1)
    //第幾頁
    const [pageNo, setPageNo] = React.useState(6)
    const [columns, setColumns] = React.useState({
        SOMEDAY: { label: "SOMEDAY", name: "SOMEDAY", width: 100, type: "text", required: false, noShowSelect: true, orderSeq: 1 },
        RANGETIME: { label: "RANGETIME", name: "RANGETIME", width: 60, type: "text", required: true, xs: 6, sm: 6, md: 3, orderSeq: 2 },
        Limit: { label: "Limit", width: 60, name: "Limit", type: "text", required: true, xs: 6, sm: 6, md: 3, noShowSelect: true, tableFormat: "number", orderSeq: 3 },
        DY: { label: "DY", name: "DY", width: 60, type: "text", required: true, noShowSelect: true, xs: 6, sm: 6, md: 3, tableFormat: "number", orderSeq: 4 },
        CW: { label: "CW", name: "CW", width: 60, type: "text", required: true, noShowSelect: true, xs: 6, sm: 6, md: 3, tableFormat: "number", orderSeq: 5 },
        AMQC: { label: "AMQC", name: "AMQC", width: 70, type: "text", required: true, noShowSelect: true, xs: 6, sm: 6, md: 3, tableFormat: "number", orderSeq: 6 },
        PMQC: { label: "PMQC", name: "PMQC", width: 70, type: "text", required: true, noShowSelect: true, xs: 6, sm: 6, md: 3, tableFormat: "number", orderSeq: 7 },
        AMGC: { label: "AMGC", name: "AMGC", width: 70, type: "text", required: true, noShowSelect: true, xs: 6, sm: 6, md: 3, tableFormat: "number", orderSeq: 8 },
        PMGC: { label: "PMGC", name: "PMGC", width: 70, type: "text", required: true, noShowSelect: true, xs: 6, sm: 6, md: 3, tableFormat: "number", orderSeq: 9 },
        AMBC: { label: "AMBC", name: "AMBC", width: 70, type: "text", required: true, noShowSelect: true, xs: 6, sm: 6, md: 3, tableFormat: "number", orderSeq: 10 },
        PMBC: { label: "PMBC", name: "PMBC", width: 70, type: "text", required: true, noShowSelect: true, xs: 6, sm: 6, md: 3, tableFormat: "number", orderSeq: 11 },
        FL: { label: "FL", name: "FL", width: 60, type: "text", required: true, noShowSelect: true, xs: 6, sm: 6, md: 3, tableFormat: "number", orderSeq: 12 },
        Hear: { label: "Hear", name: "Hear", width: 70, type: "text", required: true, noShowSelect: true, xs: 6, sm: 6, md: 3, tableFormat: "number", orderSeq: 13 },
        Ultra: { label: "Ultra", name: "Ultra", width: 60, type: "text", required: true, noShowSelect: true, xs: 6, sm: 6, md: 3, tableFormat: "number", orderSeq: 14 },
        Lung: { label: "Lung", name: "Lung", width: 60, type: "text", required: true, noShowSelect: true, xs: 6, sm: 6, md: 3, tableFormat: "number", orderSeq: 15 },
        DXA: { label: "DXA", name: "DXA", width: 60, type: "text", required: true, noShowSelect: true, xs: 6, sm: 6, md: 3, tableFormat: "number", orderSeq: 16 },
        Auto: { label: "Auto", name: "Auto", width: 60, type: "text", required: true, noShowSelect: true, xs: 6, sm: 6, md: 3, tableFormat: "number", orderSeq: 17 },
        MP: { label: "MP", name: "MP", width: 60, type: "text", required: true, noShowSelect: true, xs: 6, sm: 6, md: 3, tableFormat: "number", orderSeq: 18 },
        VIP: { label: "VIP", name: "VIP", width: 60, type: "text", required: true, noShowSelect: true, xs: 6, sm: 6, md: 3, tableFormat: "number", orderSeq: 19 },
        VIPRest: { label: "VIPRest", name: "VIPRest", width: 70, type: "text", required: true, noShowSelect: true, xs: 6, sm: 6, md: 3, tableFormat: "number", orderSeq: 20 },
    })
    React.useEffect(() => {
        let noshowTable = [];
        Object.values(columns).map(item => {
            if (item.noshowTable === true) {
                // console.log(item.name)
                noshowTable.push(item.name)
            }
        })
        let showColumns = _.omit(columns, noshowTable);        //轉換
        setOrderRows(prev => PF.dataSheetGridFormat(rows, Object.keys(showColumns)))
    }, [columns])
    //轉換
    let noshowTable = [];
    Object.values(columns).map(item => {
        if (item.noshowTable === true) {
            // console.log(item.name)
            noshowTable.push(item.name)
        }
    })
    let showColumns = _.omit(columns, noshowTable)
    // const [showColumns, setShowColumn] = React.useState(_.omit(columns, noshowTable))
    //let z22 = _.orderBy(z2, ['orderSeq']);  //排序
    //let z3 = z2.map(item=>(item.name));//只取標頭
    // console.log(z22);     //依照column順序排序
    const [orderRows, setOrderRows] = React.useState(PF.dataSheetGridFormat(rows, Object.keys(showColumns)))
    //雙擊
    const handleDoubleClick = (i, j, e) => {
        console.log(rows[i]);
    }
    const RowStyleFunc = (rows, index) => {

        return new Date(rows[index]["SOMEDAY"]).getDate() % 2 != 0 ? dark ? indigo[900] : indigo[50] : "";
    }

    const handleQuery = prop => {
        if (!_.isEmpty(MornJoy.startDate.value) && !_.isEmpty(MornJoy.endDate.value)) {
        } else {
            alert("請輸入日期")
            return
        }

        setLoading(true);
        PF.instance({
            method: "post",
            url: PF.url + "/Reservation/GetWeeklyData",
            data: Qs.stringify({ parameter: { startDate: MornJoy.startDate.value, endDate: MornJoy.endDate.value } }),
            // headers: { token: sessionStorage.token }
        })
            .then(function (response) {
                // alert("完成")
                const { TotalRecord, rows } = response.data;
                console.log(rows)
                if (TotalRecord > 0) {
                    enqueueSnackbar("查詢成功", { variant: "success", style: { whiteSpace: 'pre-line' } });
                    setRows(prev => rows);
                    setOrderRows(prev => [...PF.dataSheetGridFormat(rows, Object.keys(showColumns))]);

                }
                else {
                    enqueueSnackbar("查無資料", { variant: "warning", style: { whiteSpace: 'pre-line' } });
                }
                setLoading(false);
            })

    };
    const handleDateChange = (name, e, v) => {
        setMornJoy(prevState => ({
            ...prevState,
            [name]: {
                ...prevState[name],
                value: v
            }
        }));
    }


    return (
        <>
            <Paper elevation={3} style={{ margin: "10px", padding: "20px" }}>
                <DarkModeSwitch
                    style={{ marginBottom: '2rem', float: "right" }}
                    checked={dark}
                    onChange={() => dispatch(actions.THEME_SET({ theme: !dark }))}
                    onMouseDown={() => playActive()}
                    size={20} />
                <form ref={formRef}>
                    <MuiPickersUtilsProvider utils={MomentUtils}>
                        {Object.values(MornJoy).slice(0, 2).map((item, key) => {
                            if (item.format === "date") {

                                return (<KeyboardDatePicker
                                    format="YYYY/MM/DD"
                                    key={key}
                                    views={["year", "month", "date"]}
                                    // fullWidth
                                    autoOk
                                    autoComplete="off"
                                    clearable
                                    type="datetime"
                                    name={item.name}
                                    required={item.required}
                                    error={item.error || false}
                                    helperText={
                                        item.error ? (
                                            item.helperText
                                        ) : null
                                    }
                                    todayLabel={< TodayIcon />}
                                    showTodayButton
                                    minDate={item.minDate || new Date("1900-01-01")}
                                    maxDate={item.maxDate || new Date("2100-01-01")}
                                    clearLabel={"清除"}
                                    label={item.label}
                                    value={item.value}
                                    inputValue={item.value}
                                    onChange={(event, value) =>
                                        handleDateChange(item.name, event, value)
                                    }
                                />
                                )
                            } else {
                                // return (<TextField
                                //     // variant="filled"
                                //     key={key}
                                //     helperText={item.error ? item.helperText : null}
                                //     autoComplete="off"
                                //     error={item.error || false}
                                //     required={item.required || false}
                                //     // fullWidth
                                //     name={item.name}
                                //     label={item.label}
                                //     inputProps={{ ...item }}
                                //     value={item.value}
                                //     onChange={handleTxtChange}
                                //     inputProps={{
                                //         ...item //像是minLength、pattern
                                //         // pattern: "[0-9]{4}/(0[1-9]|1[012])/(0[1-9]|1[0-9]|2[0-9]|3[01])"
                                //     }} />
                                // )

                            }

                        })}
                        <Button onClick={handleQuery} variant={"outlined"}>查找</Button>
                    </MuiPickersUtilsProvider>

                </form>
                <br />
                <InteriorTable
                    width={"100%"}
                    style={{ width: "100%" }}
                    className={classes['data-grid']}
                    orderRows={orderRows}                    //需轉換格式
                    setRows={setRows}           //傳入方法
                    rows={rows}         //原來傳入
                    setOrderRows={setOrderRows}
                    // columns={Object.values(showColumns)} //需轉換格式
                    showColumns={showColumns}
                    setColumns={setColumns}     //傳入方法
                    columns={columns}   //原來傳入
                    enableCheck={enableCheck}   //不允許更改
                    multiChk={multiChk} //允許多選checkBOx
                    checkSelections={checkSelections}       //checkBox
                    setCheckSelections={setCheckSelections} //checkBox方法
                    listRef={listRef}   //用來scroll to an item
                    pageCount={pageCount}
                    pageNo={pageNo}
                    setPageNo={setPageNo}
                    handleDoubleClick={handleDoubleClick}
                    selected={selected}
                    setSelected={setSelected}
                    defaultFrozen={1}
                    defaultWidth={"95%"}
                    RowStyleFunc={RowStyleFunc}
                    CopyWithHeader={true}
                />


            </Paper>
            <Backdrop className={classes.backdrop} open={loading} >
                <CircularProgress color="inherit" />
            </Backdrop>
        </>);
}
export default WeeklyBooking;